import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import { useSEO } from '@/hooks/useSEO';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategoryGrid from './components/CategoryGrid';
import PopularComics from './components/PopularComics';
import LatestUpdates from './components/LatestUpdates';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';
import { faqs } from '@/mocks/comics';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫之家',
  url: 'http://bferj.cn/',
  description: '韩漫之家拥有庞大的免费漫画大全和精准的好看韩漫推荐，无遮挡下拉式在线阅读带来极致纯净的视觉享受。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://bferj.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫之家',
  url: 'http://bferj.cn/',
  description: '国内领先的韩国漫画在线免费阅读平台',
  foundingDate: '2019',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'hello@bferj.cn',
    telephone: '+86-400-888-8888',
  },
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'CN',
    addressLocality: '北京',
    addressRegion: '朝阳区',
    streetAddress: '望京SOHO T1座 1506室',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首页',
      item: 'http://bferj.cn/',
    },
  ],
};

export default function HomePage() {
  useSEO({
    title: '韩漫之家 - 免费漫画大全 | 好看的韩国漫画推荐 | 无遮挡下拉式韩漫在线阅读',
    description: '韩漫之家拥有庞大的免费漫画大全和精准的好看韩漫推荐，无遮挡下拉式在线阅读带来极致纯净的视觉享受。涵盖恋爱、奇幻、动作、悬疑等多种类型韩漫，每日更新热门韩国漫画。',
    keywords: '韩漫之家, 免费漫画大全, 好看韩漫推荐, 无遮挡下拉式, 在线阅读, 韩国漫画, 韩漫',
    canonicalUrl: 'http://bferj.cn/',
    ogTitle: '韩漫之家 - 免费漫画大全 | 好看的韩国漫画推荐',
    ogDescription: '韩漫之家拥有庞大的免费漫画大全和精准的好看韩漫推荐，无遮挡下拉式在线阅读带来极致纯净的视觉享受。',
    ogType: 'website',
    twitterCard: 'summary_large_image',
  });

  return (
    <>
      <ScrollToTop />
      <SchemaOrg data={websiteSchema} />
      <SchemaOrg data={organizationSchema} />
      <SchemaOrg data={faqSchema} />
      <SchemaOrg data={breadcrumbSchema} />

      <Navbar />

      <main>
        <article>
          <HeroSection />
          <FeaturedComics />
          <CategoryGrid />
          <PopularComics />
          <LatestUpdates />
          <StatsSection />
          <FAQSection />
        </article>
      </main>

      <Footer />
    </>
  );
}